import {Injectable} from '@angular/core';
import {ServiceConfig} from './service-config';
import { HttpClient } from '@angular/common/http';
@Injectable()
export class PostTmpsService {

  private host = ServiceConfig.hostImage;
  public baseUrl = this.host + '/api/post-tmp/';
  public baseUrlPostAnalytis = this.host + '/api/ipcc/post';
  public data: any;

  constructor(private http: HttpClient) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
  }

  public index(body) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    let url = this.baseUrl + '?token=' + this.data.token;
    //console.log(url);
    return this.http.post<any>(url,body);
  }

  public create(body) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    let url = this.baseUrl + 'create?token=' + this.data.token;
    //console.log(url);
    return this.http.post<any>(url, body);
  }

  public getPostByProjectId(body) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    let url = this.baseUrl + 'getPostByProjectId?token=' + this.data.token;
    //console.log(url);
    return this.http.post<any>(url,body);
  }


  public update(body) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    let url = this.baseUrl + 'update?token=' + this.data.token;
    //console.log(url);
    return this.http.post<any>(url, body);
  }

  public delete(body) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    let url = this.baseUrl + '/delete?token=' + this.data.token;
    //console.log(url);
    return this.http.post<any>(url, body);
  }

  public analytis(body) {
    let url = this.baseUrlPostAnalytis + '/postAnalytis?token=' + this.data.token;
    //console.log(url);
    return this.http.post<any>(url, body);
  }

  public compareImage(body) {
    let url = this.baseUrlPostAnalytis + '/compareImage?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_services/post-tmp.service.ts